<div class="checkin__payments__slideout">
  <div class="checkin__payments__slideout__wrapper">
    <span>{{ 'look-payments-list' | translate }}</span>

    <div class="checkin__payments__slideout__details">
      <app-payments-detail-item
        *ngFor="let payment of payments"
        [payment]="payment"
        [ngClass]="{ 'selected': payment?.selected }">
      </app-payments-detail-item>

      <app-booking-price
        [full]="false">
      </app-booking-price>
    </div>
  </div>
  <div class="checkin__payments__slideout__buttons">
    <app-button-primary
      [customClass]="'checkin__btn__full__width'"
      [text]="'hide-payments'"
      (click)="closeSlideOutHandler()">
    </app-button-primary>
  </div>
</div>
